import { createAction, props } from '@ngrx/store';
import { Candidate } from '@shared/models';
import { JobFeaturedCandidate } from '@shared/models/job-featured-candidate';
import { Pagination } from '@shared/pagination';

export const candidatesPageList = createAction(
  '[Candidates Page] List',
  props<{ payload: Pagination }>(),
);

export const candidatesPageClear = createAction('[Candidates Page] Clear');

export const candidatesLoad = createAction('[Candidates Page] Load', props<{ payload?: any }>());

export const candidatesLoadSuccess = createAction(
  '[Candidates Page] Load Success',
  props<{ payload: Pagination<Candidate> }>(),
);

export const candidatesLoadFail = createAction(
  '[Candidates Page] Load Fail',
  props<{ error?: any }>(),
);

export const candidatesSimilarClear = createAction('[Candidates Page ] Similar Clear');

export const candidatesSimilarList = createAction(
  '[Candidates Page] Similar List',
  props<{ payload?: Pagination }>(),
);

export const candidatesSimilarLoad = createAction(
  '[Candidates Page] Similar List Load',
  props<{ payload: number }>(),
);

export const candidatesSimilarLoadSuccess = createAction(
  '[Candidates Page] Similar Load Success',
  props<{ payload: Pagination<Candidate> }>(),
);

export const candidatesJobsList = createAction(
  '[Candidates Page] Jobs List',
  props<{ payload: JobFeaturedCandidate[] }>(),
);

export const candidatesJobsLoad = createAction(
  '[Candidates Page] Jobs Load',
  props<{ payload: number }>(),
);

export const candidatesJobsLoadSuccess = createAction(
  '[Candidates Page] Jobs Load Success',
  props<{ payload: JobFeaturedCandidate[] }>(),
);

export const candidatesJobsLoadFail = createAction(
  '[Candidates Page] Jobs Load Fail',
  props<{ error?: any }>(),
);

export const removeCandidateFromTalentPoolOnStatusChange = createAction(
  '[Candidates Page] Remove Candidate From TP On Status Change',
  props<{ candidateIds: string[] }>(),
);
